const jwtDecode = require('jwt-decode');
const dayjs = require('dayjs');
import Nzh from 'nzh';

export const getOcrProvinceCityAddress = function (addressStr) {
    // 定义省市区的正则表达式
    const provinceRegex = /([\u4e00-\u9fa5]+省|[\u4e00-\u9fa5]+自治区)/;
    const cityRegex = /([\u4e00-\u9fa5]+市|[\u4e00-\u9fa5]+地区)/;
    const districtRegex = /([\u4e00-\u9fa5]+区|[\u4e00-\u9fa5]+县)/;

    // 使用正则表达式匹配省市区
    const province = addressStr.match(provinceRegex) ? addressStr.match(provinceRegex)[0] : '';
    let city = addressStr.match(cityRegex) ? addressStr.match(cityRegex)[0] : '';
    let district = addressStr.match(districtRegex) ? addressStr.match(districtRegex)[0] : '';
    city = city.replace(province, '');
    district = district.replace(city, '');
    // 提取具体地址
    const specificAddress = addressStr.replace(province, '').replace(city, '').replace(district, '');
    return {
        province: province || city,
        city,
        district: district || specificAddress,
        specificAddress
    };
};

// 阿拉伯数字转中文
export const translateNumberToChinese = function (index) {
    const nzhcn = Nzh.cn;
    return nzhcn.encodeS(index);
};
/**
 * 深拷贝
 */
export const cloneDeep = require('lodash/cloneDeep');

/**
 * 格式化时间
 * @param {时间} time
 * @param {类型} type
 * @param {链接符} join
 */
export const dateFormatFilter = function (time) {
    if (!time) return '';
    const date = new Date(time);
    const y = date.getFullYear();
    let m = date.getMonth() + 1;
    let d = date.getDate();
    let h = date.getHours();
    let min = date.getMinutes();
    let s = date.getSeconds();
    m = m < 10 ? '0' + m : m;
    d = d < 10 ? '0' + d : d;
    h = h < 10 ? '0' + h : h;
    min = min < 10 ? '0' + min : min;
    s = s < 10 ? '0' + s : s;

    return `${y}-${m}-${d} ${h}:${min}`;
};

/**
 * 将val值按照format进行格式化
 * @param {*} val
 * @param {*} format
 */
export const format = (val, format = 'YYYY-MM-DD') => {
    return dayjs(val).format(format);
};

/**
 * 解密token
 * @param {*} token
 */
export const deCodeToken = token => {
    if (token) {
        return jwtDecode(token);
    } else {
        return '';
    }
};
export const getEnums = enumName => {
    const enumList = JSON.parse(localStorage.getItem('authorEnums'));
    return enumList[enumName] || [];
};
export const getReasonEnums = applyType => {
    const applyReasonEnums = getEnums('applyReasonEnums');
    return applyReasonEnums[applyType] || {};
};
export const enumsFilter = (val, list) => {
    if (list && list.length > 0) {
        const item = list.find(item => item.key === val);
        return item?.value || '';
    }
};
export const applyReasonFilter = (val, applyType) => {
    const list = getReasonEnums(applyType);
    if (list && list.length > 0) {
        const item = list.find(item => item.key === val);
        return item?.value || '';
    }
};
/**
 * 跳转到统一登录入口
 */
export const logoutUtil = () => {
    location.href = '/login';
};

export const userLevel = () => {
    const currentUser = localStorage.getItem('userinfo');
    if (currentUser) {
        const currentUserLevel = JSON.parse(currentUser).level;
        return currentUserLevel;
    } else {
        return -1;
    }
};
